export default "__VITE_ASSET__BkASnq6A__"